// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__bwXGF","error":"Textarea_error__37MHL","readonly":"Textarea_readonly__1Ws8n","disabled":"Textarea_disabled__2XMpt"};